module.exports = __webpack_public_path__ + "static/media/hold.2c56bbd4.jpg";